Ext.define('SA.ScarboroughCrosstabEditSelectLocationMessage', {
    alias: 'widget.scarborough-crosstab-edit-select-location-message',
    extend: 'Ext.Component',

    cls: 'sa-scarborough-crosstab-edit-select-location-message',
    hidden: true,

    html: [
        '<svg class="sa-scarborough-crosstab-edit-select-location-message-arrow" width="70" height="50">',
            '<use href="#sa-icon-long-arrow-left"></use>',
        '</svg>',
        '<div class="sa-scarborough-crosstab-edit-select-location-message-text">Start by selecting a location</div>'
    ]
});